import { FC } from 'react';

import ErrorView from 'components/ErrorView';
import { useNewInsuranceCoverage } from 'features/Insurance/hooks/useNewInsuranceCoverage';
import logger from 'helpers/logger';

import PageWrapper from '../../../components/PageWrapper';
import CompleteGuaranteesList from '../../../components/PageWrapper/components/CompleteGuaranteesList';
import offers from '../../../offers';
import * as routes from '../../../routes';
import { AssuredBy, isSelectedProviderPlanId } from '../../../types';
import cover from '../assets/purchaseProtectionCover.png';
import locales from './locales';
import { insurancePlan } from './types';

const OFFER_NAME = 'Purchase Protection';
const PAGE_NAME = `Insurance${OFFER_NAME.replaceAll(' ', '')}OfferDetails Viewed`;

const PurchaseProtection: FC = () => {
  const { coverage, planId, routeState } = useNewInsuranceCoverage();

  if (!isSelectedProviderPlanId(planId)) {
    logger.error(
      `[Insurances feature]: PlanId is not correct, should be "basic", "plus", "pro" or "business", got ${planId} instead`,
    );
    return <ErrorView />;
  }

  const { isCovered, isCoveredFromPlan } = coverage.purchaseProtection;

  const guarantees = {
    ...locales.content,
    include: {
      ...locales.content.include,
      items: locales.content.include.items.map((text, index) =>
        index === 1
          ? (locales.formatString<string | number>(
              text,
              insurancePlan[planId],
            ) as string)
          : text,
      ),
    },
  };

  return (
    <PageWrapper
      assuredBy={AssuredBy.Shine}
      backButtonLink={routes.coverage}
      coverImage={cover}
      from={routeState.from}
      intercomMessage={locales.claimButton.intercomMessage}
      isCovered={isCovered}
      isCoveredFromPlan={isCoveredFromPlan}
      offer={offers.purchaseProtection}
      offerName={OFFER_NAME}
      pageName={PAGE_NAME}
      similarOffers={[
        offers.hospitalization,
        offers.mobileScreen,
        offers.computerBreakage,
      ]}
    >
      <CompleteGuaranteesList guarantees={guarantees} />
    </PageWrapper>
  );
};

export default PurchaseProtection;
